/* eslint-disable no-shadow, no-param-reassign */
import VBodyScrollLock from 'v-body-scroll-lock';
import Vue from 'vue';
import Fragment from 'vue-fragment';
import VueScreen from 'vue-screen';
import SlideUpDown from 'vue-slide-up-down';
import HoverIntent from 'vue2-hover-intent';
import { bem } from 'vue-simple-bem';
import vClickOutside from 'v-click-outside';
import vmodal from 'vue-js-modal';
import store from '../store';
import PageHeader from './components/PageHeader.vue';
import drupalMixin from './mixins/drupal';

Vue.use(Fragment.Plugin);
Vue.use(VueScreen, 'bootstrap');
Vue.use(VBodyScrollLock);
Vue.use(vmodal);
Vue.use(vClickOutside);
Vue.directive('bem', bem);
Vue.directive('hover-intent', HoverIntent);
Vue.component('slide-up-down', SlideUpDown);
Vue.mixin(drupalMixin);

/**
 * STATE
 */
const state = {
  activeSubmenu: null,
  activeWidget: null,
  searchTerm: '',
  searchSuggestions: [],
  searchIsFocused: false,
  isMobileOverlayOpen: false,
  menuData: {},
  languageUrl: '',
  languageTitle: '',
  languageDescription: '',
  languageButtontext: '',
  languageButtonclose: '',
  cartUrl: '',
  loginFormHtml: '',
  doccheckLoginBaseUrl: '/',
  isLoggedIn: false,
  accountLogoutUrl: '',
  accountName: '',
  isCartEnabled: false,
  cartCount: 0,
};

/**
 * MUTATIONS
 */
const mutations = {
  setActiveSubmenu(state, key) {
    state.activeSubmenu = key;
    // Always close all active widgets when opening a submenu
    state.activeWidget = null;
  },
  setActiveWidget(state, key) {
    state.activeWidget = key;
  },
  setIsMobileOverlayOpen(state, open) {
    state.isMobileOverlayOpen = open;
  },
  setSearchTerm(state, term) {
    state.searchTerm = term;
  },
  setSearchInputIsFocused(state, focused) {
    state.searchIsFocused = focused;
  },
};

/**
 * ACTIONS
 */
const actions = {
  openSubmenu({ commit }, key) {
    commit('setActiveSubmenu', key);
  },
  closeSubmenu({ commit }) {
    commit('setActiveSubmenu', null);
  },
  openWidget({ commit }, key) {
    commit('setActiveWidget', key);
  },
  toggleWidget({ commit, state }, key) {
    commit('setActiveWidget', state.activeWidget === key ? null : key);
  },
  closeWidget({ commit }) {
    commit('setActiveWidget', null);
  },
  toggleMobileOverlay({ commit, state }) {
    commit('setIsMobileOverlayOpen', !state.isMobileOverlayOpen);
  },
};

/**
 * GETTERS
 */
const getters = {
  activeSubmenuChildren({ activeSubmenu, menuData }) {
    if (
      activeSubmenu !== null &&
      menuData[activeSubmenu] &&
      menuData[activeSubmenu].children
    ) {
      return menuData[activeSubmenu].children;
    }
    return [];
  },
};

export default (el, initialState) => {
  store.registerModule('pageHeader', {
    namespaced: true,
    state: { ...state, ...initialState },
    mutations,
    actions,
    getters,
  });

  return new Vue({
    el,
    store,
    render: (h) => h(PageHeader),
  });
};
